import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Gradino } from '../../../../app/shared/_model/Gradino';
import { MarcaVeicolo } from '../../../../app/shared/_model/MarcaVeicolo';
import { ModelloGradino } from '../../../../app/shared/_model/ModelloGradino';
import { ModelloVeicolo } from '../../../../app/shared/_model/ModelloVeicolo';
import { Passo } from '../../../../app/shared/_model/Passo';
import { Percorso } from '../../../../app/shared/_model/Percorso';
import { Struttura } from '../../../../app/shared/_model/Struttura';

@Component({
  selector: 'app-configuratore',
  templateUrl: './configuratore.component.html',
  styles: []
})
export class ConfiguratoreComponent implements OnInit {

  constructor() { }

  @Input()  risultati: number[];
  @Output() risultatiChange = new EventEmitter<string[]>();

  @Input()  risultatiStaffe: number[];
  @Output() risultatiStaffeChange = new EventEmitter<Gradino[]>();

  @Output() queryParamsChange = new EventEmitter<any>();
  @Input()
  get queryParams() {
    return {
      step0: this.marcaSelected ? this.marcaSelected.id : undefined,
      step1: this.modelloSelected ? this.modelloSelected.id : undefined,
      step2: this.passoSelected ? this.passoSelected.id : undefined,
      step3: this.trazioneSelected ? this.trazioneSelected.value : undefined,
      step4: this.latoSelected ? this.latoSelected : undefined,
      step5: this.categorieSelected ? this.categorieSelected : []
    };
  }
  set queryParams(qp: any) {
    if (!qp) { return; }
    this.setFormStep(0);
    this.loadStep(0);
    if (qp.step0) {
      this.marcaSelected = this.marcheVeicoloVisualizzate.find(marca => marca.id === Number.parseInt(qp.step0, 10));
      this.nextStep();
    }
    if (qp.step1 && this.stepAttivo === 1) {
      this.modelloSelected = this.modelliVeicoloVisualizzati.find(modello => modello.id === Number.parseInt(qp.step1, 10));
      this.nextStep();
    }
    if (qp.step2 && this.stepAttivo === 2) {
      this.passoSelected = this.passiVisualizzati.find(passo => passo.id === Number.parseInt(qp.step2, 10));
      this.nextStep();
    }
    if (qp.step3 && this.stepAttivo === 3) {
      this.trazioneSelected = this.trazioniVisualizzate.find(trazione => trazione.value === qp.step3);
      this.nextStep();
    }
    if (qp.step4 && this.stepAttivo === 4) {
      this.latoSelected = this.latiAbilitati.find(lato => lato === qp.step4);
      this.nextStep();
    }
    if (qp.step5 && this.stepAttivo === 5) {
      this.categorieSelected = qp.step5;
      this.nextStep();
    }
  }

  /*  STEPS
    0 - Marca Veicolo
    1 - Modello Veicolo
    2 - Passo
    3 - Trazione
    4 - Lato Montaggio
    5 - Categoria
    6 - Risultati
  */
  stepOpen = 0;     // Step aperto a FE ( non collapsed )
  stepAttivo = 0;   // Ultimo step compilato

  // FE
  marcheVeicoloVisualizzate: MarcaVeicolo[] = [];
  modelliVeicoloVisualizzati: ModelloVeicolo[] = [];
  passiVisualizzati: Passo[] = [];
  trazioniVisualizzate: {label: string, value: string}[] = [];
  latiAbilitati: string[] = [];
  categorieAbilitate: string[] = [];

  marcaSelected: MarcaVeicolo;
  modelloSelected: ModelloVeicolo;
  passoSelected: Passo;
  trazioneSelected: any;
  latoSelected: string;
  categorieSelected: string[] = [];

  @Input() struttura: Struttura;
  formCategoria: FormGroup = new FormGroup({
    Elettrico   : new FormControl(''),
    Manuale     : new FormControl(''),
    Meccanico   : new FormControl('')
  });

  ngOnInit() {
    this.loadStep(0);
  }

  /* Click su avanti */
  nextStep() {
    this.stepOpen = ++this.stepAttivo;
    this.loadStep(this.stepAttivo);
  }

  /* Click su uno step precedente */
  setFormStep(step: number) {
    if (step < this.stepAttivo) {
      this.stepAttivo = step;
      // tslint:disable: no-switch-case-fall-through
      // Questo switch non ha i break perché va a cascata partendo dallo step indicato
      switch (step) {
        case 0: // Marca
          this.modelloSelected = null;
        case 1: // Modello
          this.passoSelected = null;
        case 2: // Passo
          this.trazioneSelected = null;
        case 3: // Trazione
          this.latoSelected = null;
        case 4: // Lato montaggio
          this.categorieSelected = [];
          this.formCategoria.get('Manuale').setValue(false);
          this.formCategoria.get('Elettrico').setValue(false);
          this.formCategoria.get('Meccanico').setValue(false);
        case 5: // Categoria
          this.risultati = null;
        case 6: // Fine
          this.risultati = null;
      }
      this.risultatiChange.emit(this.distinctGradini(this.filtra()));
    }
  }

  loadStep(step: number) {
    this.risultati = null;
    let skip = false;

    switch (step) {
      case 0: // Marca
        this.marcheVeicoloVisualizzate = [];
        this.filtra().forEach(percorso => {
          if (!this.marcheVeicoloVisualizzate.find(marca => percorso.modello.idMarca === marca.id)) {
            const newMarca = this.struttura.marche.find(marca => marca.id === percorso.modello.idMarca);
            this.marcheVeicoloVisualizzate.push(newMarca);
          }
        });
        this.marcheVeicoloVisualizzate = this.marcheVeicoloVisualizzate.sort((a, b) => a.descrizione.localeCompare(b.descrizione));
        break;
      case 1: // Modello
        this.modelliVeicoloVisualizzati = [];
        this.filtra().forEach(percorso => {
          if (percorso.modello.descrizione && !this.modelliVeicoloVisualizzati.find(modello => percorso.modello.descrizione === modello.descrizione)) {
            this.modelliVeicoloVisualizzati.push(percorso.modello);
          }
        });
        this.modelliVeicoloVisualizzati = this.modelliVeicoloVisualizzati.sort((a, b) => a.descrizione.localeCompare(b.descrizione));
        break;
      case 2: // Passo
        this.passiVisualizzati = [];
        this.filtra().forEach(percorso => {
          if (!this.passiVisualizzati.find(passo => percorso.passo.codice === passo.codice) && percorso.passo.codice) {
            this.passiVisualizzati.push(percorso.passo);
          }
        });
        this.passiVisualizzati = this.passiVisualizzati.sort((a, b) => a.codice.localeCompare(b.codice));
        if (this.passiVisualizzati.length === 1) {
          this.passoSelected = this.passiVisualizzati[0];
          skip = true;
        }
        break;
      case 3: // Trazione
        this.trazioniVisualizzate = [];
        this.filtra().forEach(percorso => {
          if (!this.trazioniVisualizzate.find(trazione => percorso.trazione === trazione.value) && percorso.trazione) {
            const newTrazione = {label: 'String', value: percorso.trazione};
            if (newTrazione.value === 'AWD') { newTrazione.label = 'TRAZIONE_INTEGRALE'; }
            if (newTrazione.value === 'RWD') { newTrazione.label = 'TRAZIONE_POSTERIORE'; }
            if (newTrazione.value === 'FWD') { newTrazione.label = 'TRAZIONE_ANTERIORE'; }
            if (newTrazione.value === 'ALL') { newTrazione.label = 'TRAZIONE_ALL'; }
            this.trazioniVisualizzate.push(newTrazione);
          }
        });
        if (this.trazioniVisualizzate.length === 1) {
          this.trazioneSelected = this.trazioniVisualizzate[0];
          skip = true;
        }
        break;
      case 4: // Lato montaggio
        this.latiAbilitati = [];
        this.filtra().forEach(percorso => {
          if (!this.latiAbilitati.find(lato => percorso.latoMontaggio === lato) && percorso.latoMontaggio) {
          this.latiAbilitati.push(percorso.latoMontaggio);
          }
        });
        if (this.latiAbilitati.length === 1) {
          this.latoSelected = this.latiAbilitati[0];
          skip = true;
        }
        break;
      case 5: // Categoria
        this.categorieAbilitate = [];
        this.filtra().forEach(percorso => {
          percorso.gradini.forEach(gradino => {
            if (!this.categorieAbilitate.find(categoria => gradino.modello.categoria === categoria) && gradino.modello.categoria) {
              this.categorieAbilitate.push(gradino.modello.categoria);
            }
            const input = this.formCategoria.get(gradino.modello.categoria);
            if (input) {
              input.enable();
              input.setValue(true);
            }
          });
        });
        break;
      case 6: // Fine
        this.categorieSelected = [];
        if (this.formCategoria.get('Elettrico').value === true) { this.categorieSelected.push('Elettrico'); }
        if (this.formCategoria.get('Manuale').value === true) { this.categorieSelected.push('Manuale'); }
        if (this.formCategoria.get('Meccanico').value === true) { this.categorieSelected.push('Meccanico'); }
        const percorsi = this.filtra();
        if (percorsi.length === 1) {
          this.queryParamsChange.emit(this.queryParams);
          this.risultatiStaffeChange.emit(this.filtraRisultati(percorsi[0]));
        }
        setTimeout( () => {
            window.scrollTo({ top: 380, behavior: 'smooth' });
          }, 100);

        return;
    }

    if (skip) {
      this.nextStep();
    }

    this.queryParamsChange.emit(this.queryParams);
    this.risultatiChange.emit(this.distinctGradini(this.filtra()));
  }

  filtra(): Percorso[] {
    if (!this.struttura) { return; }

    let percorsi: Percorso[] = [].concat(this.struttura.percorsi);

    if (this.marcaSelected) {
      percorsi = percorsi.filter(percorso => percorso.modello.idMarca === this.marcaSelected.id);
    }

    if (this.modelloSelected) {
      percorsi = percorsi.filter(percorso => percorso.modello.id === this.modelloSelected.id);
    }

    if (this.passoSelected) {
      percorsi = percorsi.filter(percorso => percorso.passo.id === this.passoSelected.id);
    }

    if (this.trazioneSelected) {
      percorsi = percorsi.filter(percorso => percorso.trazione === this.trazioneSelected.value);
    }

    if (this.latoSelected) {
      percorsi = percorsi.filter(percorso => percorso.latoMontaggio === this.latoSelected);
    }

    return percorsi;
  }

  distinctGradini( percorsi: Percorso[] ): string[] {
    if (!percorsi) { return[]; }

    const modelli: ModelloGradino[] = [];
    percorsi.forEach(percorso => {
      percorso.gradini.forEach(gradino => {
        if (!modelli.find(modello => modello.codice === gradino.modello.codice)) {
          modelli.push(gradino.modello);
        }
      });
    });
    return modelli.sort((g1, g2) => g1.ordine - g2.ordine).map(({codice}) => codice);
  }

  latoDisabled(lato) {
    return this.latiAbilitati.find(latoAbilitato => latoAbilitato === lato) ? null : true;
  }

  categoriaDisabled(categoria) {
    return this.categorieAbilitate.find(categorieAbilitata => categorieAbilitata === categoria) ? null : true;
  }

  get categorieSelectedLabel() {
    return this.categorieSelected.map(categoria => {
      switch (categoria) {
        case 'Manuale': return 'CATEGORIA_MANUALE';
        case 'Elettrico': return 'CATEGORIA_ELETTRICO';
        case 'Meccanico': return 'CATEGORIA_MECCANICO';
      }
    });
  }

  isCategoriaSelected(categoria) {
    return this.categorieSelected.find(cat => cat === categoria);
  }

  filtraRisultati(percorso: Percorso): Gradino[] {
    const gradini: Gradino[] = [].concat(percorso.gradini);
    console.log('Finale', gradini.filter(gradino => this.categorieSelected.find( categoria => gradino.modello.categoria === categoria )).sort((g1, g2) => g1.modello.ordine - g2.modello.ordine));
    return gradini.filter(gradino => this.categorieSelected.find( categoria => gradino.modello.categoria === categoria )).sort((g1, g2) => g1.modello.ordine - g2.modello.ordine);
  }

}
